import React from "react";
import LegalPage, { LegalSection } from "../components/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      title="이용약관"
      description="Disparty 서비스와 디지털 상품 거래에 적용되는 기본 약관입니다."
      effectiveDate="2026년 8월 3일"
    >
      <LegalSection title="제1조 목적 및 사업자">
        <p>이 약관은 씨에스소프트(대표 정원우, 이하 "회사")가 제공하는 Disparty 서비스의 이용 조건과 회사 및 이용자의 권리·의무를 정합니다.</p>
        <p>사업자등록번호 425-43-01340 · 충청북도 진천군 덕산읍 대월로 127 · 010-9174-6988 · inhyuk0078@gmail.com</p>
      </LegalSection>
      <LegalSection title="제2조 서비스의 내용">
        <p>회사는 Discord 서버 탐색·홍보, 서버 관리, 서버 카드 디자인 거래, 결제·환불 지원 및 이에 부수하는 서비스를 제공합니다. 운영상 필요한 경우 서비스의 일부를 변경할 수 있으며 중요한 변경은 사전에 알립니다.</p>
      </LegalSection>
      <LegalSection title="제3조 계정과 이용자의 책임">
        <p>이용자는 본인의 Discord 계정을 사용해야 하며, 계정 접근 정보와 서버 관리 권한을 안전하게 관리해야 합니다. 타인의 권리 침해, 불법 정보 게시, 결제 악용, 서비스 방해 행위는 금지됩니다.</p>
        <p>미성년자가 유료 상품을 구매하거나 판매하려면 법정대리인의 동의가 필요할 수 있습니다. 법정대리인의 동의가 없는 계약은 관계 법령에 따라 취소될 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="제4조 크리에이터 상품과 통신판매중개">
        <p>회사가 직접 판매하는 상품을 제외하고, 크리에이터가 등록한 상품의 거래 당사자는 구매자와 해당 판매자입니다. 회사는 통신판매중개자로서 상품 등록 공간, 결제·환불 접수, 거래 기록 및 분쟁 처리 창구를 제공합니다.</p>
        <p>회사는 구매 전에 판매자 유형과 필요한 판매자 정보를 표시합니다. 개인 판매자의 비공개 신원 정보는 분쟁 해결이나 법령상 요청이 있는 경우에 한해 필요한 범위에서 제공합니다.</p>
      </LegalSection>
      <LegalSection title="제5조 주문, 결제 및 디지털 상품 공급">
        <p>구매자는 상품, 가격, 판매자, 적용할 서버와 환불 조건을 확인한 뒤 주문합니다. 결제 완료 시 구매한 서버 카드가 선택한 서버에 즉시 적용되어 디지털 콘텐츠의 공급이 시작됩니다.</p>
        <p>표시 가격은 부가가치세가 포함된 최종 결제 금액이며, 결제 승인은 결제대행사를 통해 처리됩니다. 주문 및 동의 기록은 구매 내역과 관련 법령이 정한 기간 동안 보관됩니다.</p>
      </LegalSection>
      <LegalSection title="제6조 청약철회와 환불">
        <p>청약철회와 환불은 환불 정책 및 관계 법령을 따릅니다. 미사용 상품은 원칙적으로 결제일부터 7일 이내 철회할 수 있습니다. 구매자가 즉시 공급에 명시적으로 동의하고 상품이 서버에 적용된 경우 단순 변심 철회가 제한될 수 있습니다.</p>
        <p>표시·광고 내용과 다르거나 계약 내용대로 이행되지 않은 경우에는 공급일부터 3개월 이내 또는 그 사실을 안 날부터 30일 이내에 환불을 요청할 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="제7조 게시물과 지식재산권">
        <p>이용자가 등록한 이미지, GIF, 문구 및 디자인의 권리는 해당 권리자에게 있습니다. 이용자는 서비스를 운영하고 상품을 전시·판매·공급하는 데 필요한 범위에서 회사에 비독점적 이용 권한을 부여합니다. 권리 침해 신고가 접수되면 회사는 해당 콘텐츠의 노출을 중단하거나 삭제할 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="제8조 서비스 제한과 책임">
        <p>회사는 법령 위반, 권리 침해, 결제 부정 사용, 보안 위협 또는 반복적인 운영 정책 위반이 확인되면 사전 통지 후 이용을 제한할 수 있습니다. 긴급한 피해 방지를 위해 선조치한 경우에는 지체 없이 사유를 알립니다.</p>
        <p>회사는 고의 또는 과실로 발생한 손해에 대해 관계 법령에 따른 책임을 부담하며, 법령상 배제할 수 없는 책임을 제한하지 않습니다.</p>
      </LegalSection>
      <LegalSection title="제9조 분쟁 처리와 약관 변경">
        <p>거래 관련 문의는 inhyuk0078@gmail.com 또는 010-9174-6988로 접수할 수 있습니다. 회사는 접수 진행 상황과 처리 결과를 관계 법령이 정한 기간 안에 안내합니다.</p>
        <p>회사는 약관 변경 시 시행일과 변경 사유를 서비스에 공지합니다. 이용자에게 불리한 중요한 변경은 원칙적으로 30일 전에 알리며, 수수료·정산 등 판매자에게 중요한 변경은 별도 동의를 받습니다.</p>
      </LegalSection>
    </LegalPage>
  );
}
